import { dataHooks } from '@wix/data-hooks';

export const textTyperDataHooks = dataHooks<{
  base: { isTypingEnd: boolean };
}>('text-typer');
